import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  filtersRequest: null,
  filtersSuccess: ['result'],
  filtersFailure: ['error'],

  filtersSaveRequest: ['data'],
  filtersSaveSuccess: ['saveResult'],
  filtersSaveReset: null,

  filtersLoadRequest: null,
  filtersLoadSuccess: ['loadResult'],
  filtersLoadReset: null,

  filtersUpdateRequest: ['data'],
  filtersUpdateSuccess: ['updateResult'],
  filtersUpdateReset: null,

  filtersDeleteRequest: ['id'],
  filtersDeleteSuccess: ['deleteResult'],
  filtersDeleteReset: null,

  filtersAddToList: ['propName', 'value'],
  filtersRemoveFromList: ['propName', 'value'],
  filtersSet: ['propName', 'value'],

  filtersReset: null,
  filtersFetchingReset: null,

  filtersChangeByPreset: ['filters'],
})

export const FiltersTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  result: {},
  error: null,
  fetching: false,

  saveResult: null,
  saveFetching: false,

  loadResult: [],
  loadFetching: false,

  updateResult: null,
  updateFetching: false,

  deleteResult: null,
  deleteFetching: false,

  tags: [
    {
      id: 'status_1',
      name: 'status',
      display_name: 'Active',
      value: 1,
    },
    {
      id: 'status_2',
      name: 'status',
      display_name: 'Inactive',
      value: 2,
    },
    {
      id: 'page_status_1',
      name: 'page_status',
      display_name: 'Active',
      value: 1,
    },
    {
      id: 'page_status_2',
      name: 'page_status',
      display_name: 'Inactive',
      value: 2,
    },
    {
      id: 'platform_1',
      name: 'platform',
      display_name: 'Instagram',
      value: 1,
    },
    {
      id: 'platform_2',
      name: 'platform',
      display_name: 'Facebook',
      value: 2,
    },
    {
      id: 'creative_1',
      name: 'creative',
      display_name: 'Video',
      value: 1,
    },
    {
      id: 'creative_2',
      name: 'creative',
      display_name: 'Photo',
      value: 2,
    },
    {
      id: 'creative_3',
      name: 'creative',
      display_name: 'Carousel',
      value: 3,
    },
    {
      id: 'likes_',
      name: 'likes',
      display_name: 'from 0 to 100000',
      value: [0, 100000],
    },
    {
      id: 'comments_',
      name: 'comments',
      display_name: 'from 0 to 100000',
      value: [0, 100000],
    },
    {
      id: 'shares_',
      name: 'shares',
      display_name: 'from 0 to 100000',
      value: [0, 100000],
    },
    {
      id: 'views_',
      name: 'views',
      display_name: 'from 0 to 100000',
      value: [0, 100000],
    },
    // {
    //     id: 'price_range',
    //     name: 'price_range',
    //     display_name: 'from 0 to 100000',
    //     value: [0, 100000]
    // }
  ],

  previousTags: null,

  //dateStart: moment().startOf('month').format('YYYY-MM-DD'),
  //dateEnd: moment().format('YYYY-MM-DD')
})

/* ------------- Selectors ------------- */

export const FiltersSelectors = {
  getProcess: state => state.filters.process,
  getStatus: state => state.filters.status,
  getDate: state => state.filters.date,
  getDateStart: state => state.filters.dateStart,
  getDateEnd: state => state.filters.dateEnd,
  getUser: state => state.filters.user,
}

/* ------------- Reducers ------------- */

export const filtersRequest = state => {
  //console.log("REDUX filtersRequest req");
  return state.merge({fetching: true, error: null})
}

export const filtersSuccess = (state, {result}) => {
  return state.merge({fetching: false, error: null, result: {filters: result}})
}

export const filtersFailure = (state, {error}) => {
  return state.merge({fetching: false, error})
}

export const filtersFetchingReset = state => {
  return state.merge({fetching: false, saveFetching: false, loadFetching: false, updateFetching: false, deleteFetching: false})
}

export const filtersReset = state => {
  return state.merge({
    previousTags: [...state.tags],
    tags: [...INITIAL_STATE.tags],
    //created: [],
    //seen: [],

    //date: 'today',

    //dateStart: moment().startOf('month').format('YYYY-MM-DD'),
    //dateEnd: moment().format('YYYY-MM-DD')
  })
}

export const filtersAddToList = (state, {propName, value}) => {
  let i = 0
  const list = state[propName]
  const newList = []
  for (i = 0; i < list.length; i++) {
    newList.push(list[i])
  }
  newList.push(value)
  return state.set(propName, newList)
}

export const filtersRemoveFromList = (state, {propName, value}) => {
  let i = 0
  let newList = []
  for (i = 0; i < state[propName].length; i++) {
    if (state[propName][i] === value) continue
    newList.push(state[propName][i])
  }
  return state.set(propName, newList)
}

export const filtersFilterSet = (state, {propName, value}) => {
  /*if(propName === 'tags'){
        return state.merge({tags: value, previousTags: null})
    }*/
  if (Array.isArray(propName)) {
    const data = {}
    for (let i in propName) {
      data[propName[i]] = value[i]
    }

    return state.merge({...data})
  } else {
    return state.set(propName, value)
  }
}

export const filtersSaveRequest = (state, {data}) => {
  return state.merge({saveFetching: true})
}

export const filtersSaveSuccess = (state, {saveResult}) => {
  return state.merge({saveFetching: false, saveResult})
}

export const filtersSaveReset = state => {
  return state.merge({saveFetching: false, saveResult: null})
}

export const filtersLoadRequest = state => {
  return state.merge({loadFetching: true})
}

export const filtersLoadSuccess = (state, {loadResult}) => {
  return state.merge({loadFetching: false, loadResult: loadResult})
}

export const filtersLoadReset = state => {
  return state.merge({loadFetching: false, loadResult: null})
}

export const filtersUpdateRequest = (state, {data}) => {
  return state.merge({deleteFetching: true})
}

export const filtersUpdateSuccess = (state, {updateResult}) => {
  return state.merge({updateFetching: false, updateResult})
}

export const filtersUpdateReset = state => {
  return state.merge({updateFetching: false, updateResult: null})
}

export const filtersDeleteRequest = (state, {id}) => {
  return state.merge({deleteFetching: true})
}

export const filtersDeleteSuccess = (state, {deleteResult}) => {
  return state.merge({deleteFetching: false, deleteResult})
}

export const filtersDeleteReset = state => {
  return state.merge({deleteFetching: false, deleteResult: null})
}

export const filtersChangeByPreset = (state, {filters}) => {
  return state.merge({...filters})
}

/* ------------- Hookup Reducers To Types ------------- */
//processStatusRequest
export const reducer = createReducer(INITIAL_STATE, {
  [Types.FILTERS_REQUEST]: filtersRequest,
  [Types.FILTERS_SUCCESS]: filtersSuccess,
  [Types.FILTERS_FAILURE]: filtersFailure,

  [Types.FILTERS_ADD_TO_LIST]: filtersAddToList,
  [Types.FILTERS_REMOVE_FROM_LIST]: filtersRemoveFromList,
  [Types.FILTERS_SET]: filtersFilterSet,

  [Types.FILTERS_RESET]: filtersReset,

  [Types.FILTERS_FETCHING_RESET]: filtersFetchingReset,

  [Types.FILTERS_SAVE_REQUEST]: filtersSaveRequest,
  [Types.FILTERS_SAVE_SUCCESS]: filtersSaveSuccess,
  [Types.FILTERS_SAVE_RESET]: filtersSaveReset,

  [Types.FILTERS_LOAD_REQUEST]: filtersLoadRequest,
  [Types.FILTERS_LOAD_SUCCESS]: filtersLoadSuccess,
  [Types.FILTERS_LOAD_RESET]: filtersLoadReset,

  [Types.FILTERS_UPDATE_REQUEST]: filtersUpdateRequest,
  [Types.FILTERS_UPDATE_SUCCESS]: filtersUpdateSuccess,
  [Types.FILTERS_UPDATE_RESET]: filtersUpdateReset,

  [Types.FILTERS_DELETE_REQUEST]: filtersDeleteRequest,
  [Types.FILTERS_DELETE_SUCCESS]: filtersDeleteSuccess,
  [Types.FILTERS_DELETE_RESET]: filtersDeleteReset,

  [Types.FILTERS_CHANGE_BY_PRESET]: filtersChangeByPreset,
})
